import store from "../store/index"
// 获取token
export function getSyncToken() {
  let storage = localStorage['Token']
  // if (process.env.NODE_ENV === 'development') {
  //     storage = process.env.DEV_API_TOKEN
  // } else {
  //     storage = localStorage['__token']
  // }
  if (!storage) {
    return ''
  }
  let currentTokenInfo = storage
  if (currentTokenInfo) {
    // 将缓存中的token信息 ，加入store
    store.commit('saveToken', currentTokenInfo)
    return currentTokenInfo
  } else {
    return ''
  }
}
// 是否要重新登录
export function isLogin () {
  if (store.state.token && new Date().getTime() < parseInt(store.state.tokenExpire) && localStorage.getItem('Token')) {
    return true
  } else {
    return false
  }
}